/* LP Wav Dream · interactions légères (galerie, offres, carrousels, barre mobile) */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- galerie produit ---------- */
  function initGallery(gal) {
    if (gal.dataset.lpdReady) return;
    gal.dataset.lpdReady = '1';
    var track = $('[data-lpd-track]', gal);
    var slides = $$('.lpd-gal__slide', track);
    var thumbs = $$('[data-lpd-thumb]', gal);
    var dotsWrap = $('[data-lpd-dots]', gal);
    var more = $('[data-lpd-more]', gal);
    if (!track || !slides.length) return;

    var dots = [];
    if (dotsWrap) {
      slides.forEach(function (s, i) {
        var d = document.createElement('span');
        if (i === 0) d.className = 'is-active';
        dotsWrap.appendChild(d);
        dots.push(d);
      });
    }

    function goTo(i) {
      var s = slides[i];
      if (!s) return;
      track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' });
    }
    /* Coloris -> photo : appelé quand la variante change (sélecteur Kaching) */
    gal.lpdGoToMedia = function (mediaId) {
      if (!mediaId) return;
      var k = slides.findIndex(function (s) { return String(s.dataset.lpdMedia) === String(mediaId); });
      if (k >= 0) goTo(k);
    };
    var thumbsWrap = $('[data-lpd-thumbs]', gal);
    function setActive(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      var t = thumbs[i];
      if (t && thumbsWrap && thumbsWrap.scrollWidth > thumbsWrap.clientWidth) {
        thumbsWrap.scrollTo({ left: t.offsetLeft - thumbsWrap.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
      }
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.dataset.lpdThumb, 10)); });
    });
    if (more) more.addEventListener('click', function () { goTo(Math.min(thumbs.length, slides.length - 1)); });

    var current = 0;
    var prev = $('[data-lpd-gal-prev]', gal), next = $('[data-lpd-gal-next]', gal);
    if (prev) prev.addEventListener('click', function () { goTo((current - 1 + slides.length) % slides.length); });
    if (next) next.addEventListener('click', function () { goTo((current + 1) % slides.length); });

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        current = Math.max(0, Math.min(slides.length - 1, i));
        setActive(current);
      });
    }, { passive: true });
  }

  /* ---------- accordéons : bascule explicite (le customizer intercepte certains clics) ---------- */
  function initAccordions() {
    $$('.lpd-acc summary, .lpd-faq summary').forEach(function (s) {
      if (s.dataset.lpdReady) return;
      s.dataset.lpdReady = '1';
      s.addEventListener('click', function (e) {
        if (s.closest('.lpd-faq') && window.matchMedia('(min-width: 1000px)').matches) return;
        e.preventDefault();
        var d = s.parentElement;
        d.open = !d.open;
      });
    });
  }

  /* ---------- offre + coloris → variante ---------- */
  function initOffers(form) {
    if (form.dataset.lpdReady) return;
    form.dataset.lpdReady = '1';
    var hidden = $('[data-lpd-variant-id]', form);
    var priceOut = $$('[data-lpd-atc-price]');
    var stickyPrice = $$('[data-lpd-sticky-price]');
    var btn = $('[data-lpd-atc]', form);
    var offers = $$('input[name="lpd-offer"]', form);
    var qoffers = $$('input[name="lpd-qoffer"]', form);
    var qtyInput = $('[data-lpd-quantity]', form);
    var colors = $$('input[name="lpd-color"]', form);
    var colorName = $('[data-lpd-color-name]', form);
    var meta = $('[data-lpd-offer-pos]', form);
    var offerPos = meta ? parseInt(meta.dataset.lpdOfferPos, 10) : 0;
    var colorPos = meta ? parseInt(meta.dataset.lpdColorPos, 10) : -1;
    var variants = [];
    try { variants = JSON.parse($('[data-lpd-variants]', form).textContent); } catch (e) { variants = []; }

    function checkedValue(list) { var c = list.filter(function (r) { return r.checked; })[0]; return c ? c.value : null; }
    function find() {
      var o = checkedValue(offers), c = checkedValue(colors);
      return variants.filter(function (v) {
        var okO = o === null || v.opts[offerPos] === o;
        var okC = colorPos < 0 || c === null || v.opts[colorPos] === c;
        return okO && okC;
      })[0] || null;
    }
    function currentQoffer() { return qoffers.filter(function (r) { return r.checked; })[0] || null; }
    function apply() {
      offers.forEach(function (r) { r.closest('.lpd-offer').classList.toggle('is-selected', r.checked); });
      qoffers.forEach(function (r) { r.closest('.lpd-offer').classList.toggle('is-selected', r.checked); });
      colors.forEach(function (r) { r.closest('.lpd-swatch-opt').classList.toggle('is-selected', r.checked); });
      var c = checkedValue(colors);
      if (colorName && c !== null) colorName.textContent = c;
      var v = find();
      if (!v) { if (btn) btn.disabled = true; return; }
      if (hidden) hidden.value = v.id;
      var q = currentQoffer();
      var qty = q ? parseInt(q.value, 10) || 1 : 1;
      if (qtyInput) qtyInput.value = qty;
      var shown = q && q.dataset.price ? q.dataset.price : v.price;
      priceOut.forEach(function (p) { p.textContent = shown; });
      stickyPrice.forEach(function (p) { p.textContent = shown; });
      if (btn) btn.disabled = !v.available;
    }
    offers.concat(qoffers, colors).forEach(function (r) { r.addEventListener('change', apply); });
    apply();

    /* Mode par défaut : le thème (ou Kaching) gère l'ajout au panier ; la LP ne fait que piloter la variante */
    var customAtc = meta && meta.dataset.lpdCustomAtc === '1';
    if (!customAtc) { initKachingSync(); return; }

    /* Garde : si un script tiers réécrit le libellé du bouton (prix), on remet le nôtre */
    if (btn && 'MutationObserver' in window) {
      var guarding = false;
      var guard = new MutationObserver(function () {
        if (guarding) return;
        var span = $('[data-lpd-atc-price]', btn);
        var v = find();
        if (!span || !v) return;
        var q = currentQoffer();
        var expected = q && q.dataset.price ? q.dataset.price : v.price;
        if (span.textContent !== expected || !btn.contains(span)) { guarding = true; apply(); guarding = false; }
      });
      guard.observe(btn, { childList: true, characterData: true, subtree: true });
    }

    /* Ajout au panier maison : la ou les paires + le produit offert, puis rafraîchissement du drawer du thème */
    var giftId = meta ? meta.dataset.lpdGiftId : '';
    var giftPer = meta ? parseInt(meta.dataset.lpdGiftPerUnit, 10) || 0 : 0;
    function refreshCart(added, cart) {
      var drawer = document.querySelector('cart-drawer');
      try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
      try { document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: added, cart: cart, baseEvent: 'variant:add' } })); } catch (e) {}
      if (drawer) {
        setTimeout(function () {
          try { if (typeof drawer.show === 'function') drawer.show(); else drawer.open = true; } catch (e) { drawer.setAttribute('open', ''); }
        }, 250);
      }
    }
    var adding = false;
    function addToCart() {
      if (adding || !hidden || !hidden.value) return;
      adding = true;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var items = [{ id: parseInt(hidden.value, 10), quantity: qty }];
      /* cadeaux : par offre-variante (data-gift-qty) sinon par unité (offres par quantité) */
      var offerRadio = offers.filter(function (r) { return r.checked; })[0];
      var giftQty = offerRadio && offerRadio.dataset.giftQty !== undefined ? (parseInt(offerRadio.dataset.giftQty, 10) || 0) : qty * giftPer;
      if (giftId && giftQty > 0) items.push({ id: parseInt(giftId, 10), quantity: giftQty });
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); }).then(function (data) {
        if (data && data.status && data.status >= 400) { throw new Error(data.description || data.message || 'Erreur'); }
        return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) { refreshCart(data.items || [], cart); });
      }).catch(function (err) {
        alert('Impossible d’ajouter au panier : ' + (err && err.message ? err.message : 'réessaie.'));
      }).then(function () {
        adding = false;
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
      });
    }
    /* Capture au niveau window : passe avant les scripts tiers (Kaching, thème) qui écoutent le bouton ou le formulaire */
    window.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-lpd-atc]') : null;
      if (!t || !form.contains(t)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addToCart();
    }, true);
    window.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addToCart();
    }, true);

    initKachingSync();

    /* Kaching Bundles rend ses propres sélecteurs de variante dans le formulaire :
       on les aligne sur les pastilles (et inversement) pour qu'un seul choix compte. */
    function initKachingSync() {
    var syncing = false;
    function kachingSelects() { return $$('kaching-bundle select', form); }
    function pushToKaching() {
      var c = checkedValue(colors);
      if (c === null) return;
      syncing = true;
      kachingSelects().forEach(function (sel) {
        var opt = [...sel.options].filter(function (o) { return o.text.trim().toLowerCase() === c.toLowerCase() || o.value.trim().toLowerCase() === c.toLowerCase(); })[0];
        if (opt && sel.value !== opt.value) { sel.value = opt.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      syncing = false;
    }
    colors.forEach(function (r) { r.addEventListener('change', pushToKaching); });
    document.addEventListener('change', function (e) {
      if (syncing) return;
      var path = e.composedPath ? e.composedPath() : [e.target];
      var sel = path[0];
      if (!sel || sel.tagName !== 'SELECT') return;
      /* le bloc Kaching peut être rendu hors du <form> : on ne teste que la présence de <kaching-bundle> dans le chemin */
      var inKaching = path.some(function (el) { return el && el.tagName === 'KACHING-BUNDLE'; }) || !!(sel.closest && sel.closest('kaching-bundle'));
      if (!inKaching) return;
      var text = (sel.selectedOptions[0] || {}).text || '';
      var vm = variants.filter(function (v) { return v.opts.some(function (o) { return String(o).toLowerCase() === text.trim().toLowerCase(); }); })[0];
      if (vm && vm.media) { var g = document.querySelector('[data-lpd-gallery]'); if (g && g.lpdGoToMedia) g.lpdGoToMedia(vm.media); }
      var match = colors.filter(function (r) { return r.value.toLowerCase() === text.trim().toLowerCase(); })[0];
      if (match && !match.checked) { match.checked = true; apply(); }
    });
    if ('MutationObserver' in window) {
      var seen = false;
      var mo = new MutationObserver(function () {
        if (!seen && kachingSelects().length) { seen = true; pushToKaching(); }
      });
      mo.observe(form, { childList: true, subtree: true });
      if (kachingSelects().length) { seen = true; pushToKaching(); }
    }
    }
  }

  /* ---------- carrousels à boutons (avis) ---------- */
  function initRail(root) {
    if (root.dataset.lpdReady) return;
    root.dataset.lpdReady = '1';
    var rail = $('[data-lpd-rail]', root);
    var prev = $('[data-lpd-prev]', root);
    var next = $('[data-lpd-next]', root);
    var dotsWrap = $('[data-lpd-rail-dots]', root);
    if (!rail) return;
    var items = $$(':scope > *', rail);
    var dots = [];

    function step() {
      var first = items[0];
      if (!first) return rail.clientWidth;
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function pages() { return Math.max(1, Math.ceil((rail.scrollWidth - rail.clientWidth) / step()) + 1); }
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];
      var n = Math.min(pages(), items.length);
      for (var i = 0; i < n; i++) {
        var d = document.createElement('span');
        if (i === 0) d.className = 'is-active';
        dotsWrap.appendChild(d);
        dots.push(d);
      }
    }
    function update() {
      var i = Math.round(rail.scrollLeft / step());
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    var raf;
    rail.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    buildDots();
    window.addEventListener('resize', buildDots);
  }

  /* ---------- barre d'achat mobile ---------- */
  function initSticky() {
    var bar = $('[data-lpd-sticky]');
    var anchor = $('[data-lpd-sticky-anchor]');
    if (!bar || !anchor || bar.dataset.lpdReady) return;
    bar.dataset.lpdReady = '1';
    var btn = $('[data-lpd-sticky-go]', bar);
    if (btn) btn.addEventListener('click', function () {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var below = e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', !e.isIntersecting && below);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---------- vidéos lues en place (poster → lecture avec le son, une seule à la fois) ---------- */
  function initVideos() {
    var items = $$('[data-lpd-video-item]');
    items.forEach(function (item) {
      if (item.dataset.lpdReady) return;
      item.dataset.lpdReady = '1';
      var video = $('video', item);
      var play = $('[data-lpd-video-play]', item);
      if (!video) return;
      function start() {
        items.forEach(function (o) { var v = $('video', o); if (v && v !== video && !v.paused) { v.pause(); } });
        video.muted = false;
        var p = video.play();
        if (p && p.catch) p.catch(function () { video.muted = true; video.play().catch(function () {}); });
      }
      function toggle() { if (video.paused) start(); else video.pause(); }
      if (play) play.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggle(); });
      video.addEventListener('play', function () { item.classList.add('is-playing'); });
      video.addEventListener('pause', function () { item.classList.remove('is-playing'); });
      video.addEventListener('ended', function () { item.classList.remove('is-playing'); video.currentTime = 0; });
      /* un toucher sur la vidéo la met en pause ou la relance (pas de contrôles natifs, ils étaient inaccessibles sur mobile) */
      video.addEventListener('click', function (e) { e.preventDefault(); toggle(); });
    });
  }

  function init() {
    $$('[data-lpd-gallery]').forEach(initGallery);
    initAccordions();
    initVideos();
    $$('form.lpd-form').forEach(initOffers);
    $$('[data-lpd-carousel]').forEach(initRail);
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
